import React from 'react';
import { useChatData } from '../context/ChatContext';
import { useNavigate } from 'react-router-dom';
import messagesIcon from '../../../assets/images/tools/Messages.svg';

const ChatNotificationBadge: React.FC = () => {
  const { totalUnread } = useChatData();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/messages');
  };

  return (
    <button
      className="chat-header-badge"
      onClick={handleClick}
      title="Messages"
    >
      <img alt="Messages" src={messagesIcon} width={"30px"} />
      {totalUnread > 0 && (
        <span className="chat-header-badge__count">
          {totalUnread > 99 ? '99+' : totalUnread}
        </span>
      )}
    </button>
  );
};

export default ChatNotificationBadge;
